<template>
	<div class="container-fluid">
		<div class="">
			<div class="articles-wrapper col-xs-12" v-if="boxes" :class="[boxes.length > boxlimit ? '' : 'no-more']">
				<div class="article-thumb col-sm-12 col-xs-12 no-gutters" v-for="(box,index) in boxes" v-if="index < boxlimit" :class="[isHome ? 'col-md-6 isHome' : 'col-lg-12']" v-in-viewport="" @click.before="gotoCase(box)">

					<div class="mask-image col-md-6 col-sm-6 col-xs-12 no-gutters">
						<div v-bind:style="{ 'background-image': 'url(' + box.elements.thumbnail_image.value[0].url + ')' }">
							<!-- <img v-lazy="box.elements.thumbnail_image.value[0].url" :alt="box.elements.thumbnail_image.value[0].name"/> -->
						</div>
					</div>

					<div class="box-info col-md-6 col-sm-6 col-xs-12 no-gutters text-center">
						<div v-if="showCategory" class="box-type-name">{{box.elements.word_category.value[0].name}}</div>
						<div class="box-title">{{box.elements.header_title.value}}</div>

						<div>
							<ul class="competency-list">
							<li v-for="approach in box.elements.approach.value" >
								<span>{{ modularContent[approach].system.name }}</span>
							</li>
							</ul>
						</div>




					</div>
				</div>
			</div>
			<template v-if="$route.path == '/words'">
				<div v-if="boxes==0" class="container-fluid no-results">
					<p>0 results for "{{search}}"</p>
					<ul>
						<li>Check the spelling of your keywords.</li>
						<li>Try using fewer, different or more general keywords.</li>
					</ul>
				</div>
			</template>
				<template v-if="boxes.length > boxlimit">
					<div v-if="$route.path == pathRoute" class="load-more-container text-center col-xs-12">
						<button class="btn_orange" @click="boxlimit += 8">LOAD MORE</button>
					</div>
				</template>

			<div v-if="showViewAll" class="load-more-container text-center col-xs-12">
				<router-link :to="pathRoute" tag="button" class="btn_orange">VIEW ALL</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'articlesSolutions',
		props:['boxes','isHome','boxlimit','search','pathRoute','showCategory','showViewAll','modularContent'],
		methods:{
			gotoCase:function(data){
				var id = data.elements.url.value;
				this.$router.push({ path: this.pathRoute+'/'+id});
				window.location.href = this.pathRoute+'/'+id;
				//window.location.reload();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// articles-solutions.vue?659d21a4